import React from 'react';
import Palestrante from '../../../Components/palestrante';

interface PalestranteType {
    foto: string;
    nome: string;
    descricao: string;
}

interface Palestra {
    slug: string;
    horario: string;
    titulo: string;
    palestrante: PalestranteType[];
}

const PalestrantesSection: React.FC<{ palestras: Palestra[] }> = ({ palestras }) => {
    return (
        <section className='py-8'>
            <div className="max-w-screen-md mx-auto px-4">
                <h3 className="text-2xl font-semibold text-center text-balance">
                    Conheça os palestrantes do evento
                </h3>

                <div className={`grid md:gap-y-8 mt-8 ${palestras.length > 1 ? 'md:grid-cols-2' : 'md:grid-cols-1'}`}>
                    {palestras.map((item, index) => (
                        <Palestrante key={index} palestra={item} className={palestras.length > 1 ? '' : '!border-r-0'} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PalestrantesSection;
